<template>
	<div id="pages-results-page">
		<section class="pages-section">
			<div class="container oversized-container">

				<breadcrumbs v-if="!justOneRow" :crumbs="[{ link: '/', label: 'Inicio' }, { label: 'Comunicados y noticias' }]" />

				<div class="row">

					<div class="col-12 col-title-s1">
						<h3 class="title">{{ title }}</h3>
					</div>

					<ui-tabs v-model="slectedTab" class="mt-3" :options="contentOptions" disable-button-mode auto-select-first/>

					<!-- slectedTab: {{ slectedTab }} -->
					
					<filters-handler v-if="!justOneRow" class="mb-4 mt-4" v-model="filterCfg" :items-count="pages.length" :per-page="perPage"/>
					
					<div class="col-12 col-pages">
						<div class="row sample-products-wrapper mt-3 xxl-5e">

							<div class="col-6 col-sm-6 col-md-4 col-lg-3 sample-product" v-for="page in pagesPaginated">
								<router-link class="outlined-box highlightOnHover" :to="'/pages/' + page.id">
									<div class="box-image">
										<div class="img">
											<!-- <img :src="page.image_url"> -->
											<api-img :comp="page.imagenes_id" />
										</div>
									</div>

									<div class="box-shot-descr">
										<h6 class="name">{{ page.titulo }}</h6>
										<p class="extracto">
											{{ page.extracto || page.descripcion || 'No hay descripción disponible.' | truncate(100) }}
										</p>

										<router-link class="btn-page" :to="'/pages/' + page.id">
											Ver contenido
										</router-link>
									</div>
								</router-link>
							</div>

						</div>
					</div>

					<div class="col-12" v-if="!catalogosGetComunicados.length">
						<b-jumbotron header="Sin contenidos" lead="En éste momento no tenemos contenidos disponibles.">
							<p>
								Regresa pronto a ver los nuevos contenidos que iremos agregando.
							</p>
						</b-jumbotron>
					</div>

					<div class="col-12" v-else-if="pagesPaginated.length === 0">
						<b-jumbotron header="Resultados no encontrados" lead="No se encontraron contenidos que coincidan con los filtros seleccionados.">
							<p>
								Intenta ajustar los filtros o busca otro término.
							</p>
						</b-jumbotron>
					</div>

				</div>

				<div class="text-right" v-if="justOneRow">
					<b-button variant="primary" class="btn-view-more" :to="'/pages'">
						Ver mas
						<span class="imoon-chevron-right"></span>
					</b-button>
				</div>

			</div>
		</section>
	</div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex';
import filtersHandler from '../daniel/filtersHandler.vue';
const contentOptions = [
	{ key: 'Comunicado', label: 'Comunicados' },
	{ key: 'Noticia', label: 'Noticias' },
	{ key: 'Promoción', label: 'Promociones' },
];
export default {
	name: 'pagesIndex',
	components: {
		filtersHandler,
	},
	props: {
		contentOptions: {
			type: Array,
			default: () => contentOptions
		},
		title: {
			type: String,
			default: 'Comunicados y noticias'
		},
		perPage: {
            type: Number,
            default: 30
        },
		justOneRow: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			slectedTab: 'Comunicado',
			filterCfg: {
				term: '',
				page: 1,
				args: { }
			}
			// pages: [
			// 	{
			// 		id: 5,
			// 		image_url: "public/images/pages/pages/page-1.jpg",
			// 		nombre: "Celular Samsung A12 5ta generación",
			// 	},
			// ],
		};
	},
	computed: {
		...mapGetters(['catalogosGetComunicados']),
		pagesPaginated() {
			const start = (this.filterCfg.page - 1) * this.perPage;
			const end = start + this.perPage;
			return this.pages.slice(start, end);
		},
		pages() {
			let filtered = _.filter(this.catalogosGetComunicados, item => {
				// Prefilter by tipo based on selected tab
				if (item.tipo !== this.slectedTab) {
					return false;
				}
				if (this.filterCfg.term && this.filterCfg.term.trim() !== '') {
					const term = this.filterCfg.term.trim().toLowerCase();
					return (
						(item.descripcion && item.descripcion.toLowerCase().includes(term)) ||
						(item.extracto && item.extracto.toLowerCase().includes(term)) ||
						(item.titulo && item.titulo.toLowerCase().includes(term))
					);
				} else {
					return true;
				}
			});
			if (this.justOneRow) 
				return filtered.slice(0, 5);
			
			return filtered;
		}
	}
};
</script>

<style lang="scss">
@import '@/sass/utils/variables.scss';

#pages-results-page {

	.pages-section {
		.container {

			padding-top: 12px;
			padding-bottom: 26px;

			.col-pages {

				// padding: 0;

				.sample-product {
					.outlined-box {
						padding: 0.5em;

						.box-image {
							.img {
								background-color: white;
								width: 100%;
								height: 100%;
								border-radius: 0.1em;
			
								img {
									object-fit: contain;
									width: 100%;
									height: 100%;
								}
							}
						}
			
						.box-shot-descr {
							padding: none;
							color: white;
			
							.price {
								/* margin-bottom: 5px; */
								/* color: #000000; */
								color: $accent;
							}
			
							.btn-page {
								margin-top: 0;
								font-size: 1em;
								border: $primary-dark-border;
								text-transform: uppercase;
								display: none;
							}
			
							.name {
								margin-bottom: 0;
								min-height: none;
								max-height: none;
								color: white;
								font-size: 1em;
							}
						}
					}
				}
			}
		}
	}
}
</style>